import { render, staticRenderFns } from "./InsCmsCat14.vue?vue&type=template&id=b87151f2&scoped=true&"
import script from "./InsCmsCat14.vue?vue&type=script&lang=ts&"
export * from "./InsCmsCat14.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsCat14.vue?vue&type=style&index=0&lang=less&"
import style1 from "./InsCmsCat14.vue?vue&type=style&index=1&id=b87151f2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87151f2",
  null
  
)

export default component.exports